import { useEffect, useState } from 'react';
import errorFormat from '../../../../../utils/errorFormat';

import { Box, CircularProgress, Grid, Paper, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import { useGetNoticiaAnexosPublicQuery, useGetNoticiaAnexosQuery } from '../noticiaAnexoApiSlice';
import { useGetNoticiaQuery } from '../noticiaApiSlice';
import { NoticiaViewAnexosCarrossel } from './NoticiaViewAnexosCarrossel';
import { NoticiaViewForm } from './NoticiaViewForm';

export const NoticiaView = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  const id = useParams().id || '';
  const { data: noticia, error } = useGetNoticiaQuery({ id: id || '', isPublicLink: true }, { skip: !id });
  const { data: noticiaAnexos, error: errorAnexos } = useGetNoticiaAnexosPublicQuery({ idNoticia: id });

  useEffect(() => {
    if (id && !noticia) {
      // navigate(configUrls.NOT_FOUND, { replace: true });
    }
  }, [id]);

  useEffect(() => {
    if (noticia) {
      setLoading(false);
    }
    if (error) {
      enqueueSnackbar('Erro ao carregar a notícia.', { variant: 'error' });
      const erroReturn: string = errorFormat(error);
      enqueueSnackbar(erroReturn, { variant: 'error' });
      console.log(error);
    }
  }, [noticia, error]);

  

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid
      container
      minHeight="100vh"
      justifyContent="center" // Centraliza no eixo horizontal
      alignItems="flex-start" // Alinha ao topo
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12} // Aqui você limita a largura no desktop
      >
        <Paper elevation={1} sx={{ paddingTop: 2, backgroundColor: theme.palette.background.paper }}>
          <NoticiaViewForm noticia={noticia} />
          {noticiaAnexos && <NoticiaViewAnexosCarrossel noticiaAnexos={noticiaAnexos} />}
        </Paper>
      </Grid>
    </Grid>
  );
};

/*
  xs → 0px até 600px (celulares)
  sm → 600px até 900px (tablets pequenos)
  md → 900px até 1200px (tablets grandes e notebooks)
  lg → 1200px até 1536px (desktops grandes)
  xl → 1536px+ (monitores muito grandes)
*/
